/*eslint-disable*/
import { Calculator, IndianRupee, PuzzleIcon, Weight, QrCode } from 'lucide-react';
import overview from '@/Images/overview.svg';
import issued from '@/Images/issued.svg';
import produced from '@/Images/produced.svg';
import primaryPackaged from '@/Images/primaryPack.svg';
import secondaryPackaged from '@/Images/secondaryPack.svg';
import dispatched from '@/Images/externalDispatch.svg';
import wastage from '@/Images/wastage.svg';

export const parentTabs = [
	{
		id: 1,
		header: 'Overview',
		value: 'OVERVIEW',
		icon: overview,
		tableTabs: 'tableTabsOverView',
	},
	{
		id: 2,
		header: 'Issued',
		value: 'ISSUED',
		icon: issued,
		tableTabs: 'tableTabsIssuedSummary',
		tableTabsNaga: 'nagaIssuedSummaryTabs',
	},
	{
		id: 3,
		value: 'PRODUCED',
		header: 'Produced',
		icon: produced,
		tableTabs: 'tableTabsProducedSummary',
		tableTabsNaga: 'nagaProducedSummaryTabs',
	},
	{
		id: 4,
		value: 'PRIMARY_PACKAGING',
		header: 'Primary Packaged',
		icon: primaryPackaged,
		tableTabs: 'tableTabsPackagedSummary',
	},
	{
		id: 5,
		value: 'SECONDARY_PACKAGING',
		header: 'Secondary Packaged',
		icon: secondaryPackaged,
		tableTabs: 'tableTabsPackagedSummary',
	},
	{
		id: 6,
		value: 'DISPATCHED',
		header: 'Distribution',
		icon: dispatched,
		tableTabs: 'tableTabsDispatchedSummary',
		tableTabsNaga: 'tableTabsDispatchedSummaryNaga',
	},
	{
		id: 7,
		value: 'WASTAGE',
		header: 'Wastage',
		icon: wastage,
		tableTabs: 'tableTabsWastageSummary',
	}
];
export const meals = [
	{
		id: 55,
		value: 'breakfast',
		header: 'BreakFast',
	},
	{
		id: 56,
		value: 'lunch',
		header: 'Lunch',
	},
	{
		id: 57,
		value: 'snacks',
		header: 'Snacks',
	},
	{
		id: 54,
		value: 'dinner',
		header: 'Dinner',
	},
	{
		id: -999,
		value: 'allDay',
		header: 'All Day',
	},
];

export const tabs = [
	{
		id: 'weight', label: 'Weight', icon: <Weight size={12} />,
	},
	// {
	// 	id: 'cost', label: 'Cost', icon: '₹', 
	// 	subTabs: [{
	// 		id: 'totalCost', lable: 'Total Cost', icon: <IndianRupee size={12}/>
	// 	},{
	// 		id: 'perUnit', lable: 'Per Unit', icon: <PuzzleIcon size={12} />
	// 	}]
	// },
	{
		id: 'percentage', label: 'Percentage', icon: '%',
	},
	{
		id: 'count', label: 'Count', icon: <Calculator size={12} />
	},
	{
		id: 'cost', label: 'Cost', icon: '₹',
		subTabs: [{
			id: 'totalCost', lable: 'Total Cost', icon: <IndianRupee size={12} />, default: true
		}, {
			id: 'perUnit', lable: 'Per Unit', icon: <PuzzleIcon size={12} />
		}]
	},
	{
		id: 'qrCount', label: 'QR Counts', icon: <QrCode size={12} />
	},
];

export const tableTabsIssuedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 2,
		value: 'products',
		label: 'Products(FG)',
	},
	{
		id: 3,
		value: 'rawMaterials',
		label: 'Raw Materials(RM)',
	},
];

export const tableTabsProducedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 2,
		value: 'outlets',
		label: 'Outlets',
	},
	{
		id: 3,
		value: 'products',
		label: 'Products(FG)',
	},

];
export const tableTabsDispatchedSummary = [
	{
		id: 1,
		value: 'outlets',
		label: 'Outlets',
	},
];
export const tableTabsDispatchedSummaryNaga = [
	{
		id: 1,
		value: 'outlets',
		label: 'Order View',
	},
];
export const tableTabsOverView = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediates Goods View(SFG)',
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
	},
];

export const tableTabsPackagedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		// label: 'Unapacked Goods View',
	},
	// {
	// 	id: 3,
	// 	value: 'batchproduct',
	// 	label: 'Batch Products View(FG)',
	// 	batch: true,
	// 	// label: 'Unapacked Goods View',
	// },
	// {
	// 	id: 3,
	// 	value: 'orderWise',
	// 	label: 'Order View',
	// }
];

export const tableTabsWastageSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 2,
		value: 'reason',
		label: 'Reason View',
	},
	// {
	// 	id: 3,
	// 	value: 'finishGood',
	// 	label: 'Finished Goods Wise',
	// }
];

export const nagaIssuedSummaryTabs = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediate Goods View(SFG)',
		batch: true,
	},
];

export const nagaProducedSummaryTabs = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediate Goods View(SFG)',
	},
	{
		id: 2,
		value: 'batchintermediate',
		label: 'Batch Intermediate View(SFG)',
		batch: true,
	},
	{
		id: 4,
		value: 'batchProduct',
		label: 'Batch Products View(FG)',
		batch: true,
	},
	// {
	// 	id: 2,
	// 	value: 'products',
	// 	// label: 'Finished Goods View(FG)',
	// 	label: 'Unapacked Goods View',
	// },
];
